/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Topic_PrivacyInputs */

const en_contact_topic_privacy = /** @type {(inputs: Contact_Topic_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy and data`)
};

const pl_contact_topic_privacy = /** @type {(inputs: Contact_Topic_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prywatność i dane`)
};

/**
* | output |
* | --- |
* | "Privacy and data" |
*
* @param {Contact_Topic_PrivacyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const contact_topic_privacy = /** @type {((inputs?: Contact_Topic_PrivacyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Topic_PrivacyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_contact_topic_privacy(inputs)
	return en_contact_topic_privacy(inputs)
});